/*
 * The tool's edit dialogs work on the same fields as the add form beside them. Opening one
 * wrote the row into the form, and closing it - Kapat, the X, Escape, or a saved update -
 * left it there: the next "Ekle" added a copy of the row that had been edited.
 *
 * keepForm(keys) takes the form's values before a dialog fills the fields; restoreForm()
 * puts them back when it closes. Lists and visibility flags a cascade rebuilds are kept by
 * reference, so the form's dropdowns come back with them.
 */
export default {
    data() {
        return {
            keptForm: null
        };
    },
    methods: {
        keepForm(keys) {
            if (this.keptForm) {
                return;
            }
            this.keptForm = keys.reduce((kept, key) => {
                kept[key] = this[key];
                return kept;
            }, {});
        },
        restoreForm() {
            if (!this.keptForm) {
                return;
            }
            Object.keys(this.keptForm).forEach((key) => {
                this[key] = this.keptForm[key];
            });
            this.keptForm = null;
        }
    }
};
